import React, { FC, useEffect, useRef, useState } from 'react';
import { Col, FormFeedback, FormGroup, Input, Label } from 'reactstrap';
import { useTranslation } from '../translations';
import { useInputState } from '../utils';
import { NewPasswordInput } from './NewPasswordInput';

interface PasswordChangeInputProps {
  readonly passwordScore: number;
  readonly isNew?: boolean;
  readonly sm?: number;
  readonly md?: number;
  readonly onChange?: (value: string) => void;
}

export const PasswordChangeInput: FC<PasswordChangeInputProps> = ({
  passwordScore,
  isNew,
  sm,
  md,
  onChange,
}) => {
  const { ts } = useTranslation();
  // TODO: This is annoying..
  const ref = useRef<HTMLInputElement>(null);
  const [pw, setPW] = useState('' as string);
  const [pwconf, setPWConf] = useInputState('' as string);
  const smHalf = sm ? sm / 2 : sm;
  const mdHalf = md ? md / 2 : md;
  const matchError = pw.length > 0 && pw !== pwconf;
  useEffect(() => {
    if (!matchError && onChange) {
      onChange(pw);
    }

    if (matchError) {
      ref.current!.setCustomValidity(ts('password_change_input.passwords_do_not_match'));
    } else if (pw.length > 0 && pwconf === '') {
      ref.current!.setCustomValidity(ts('password_change_input.confirmation_is_required'));
    } else {
      ref.current!.setCustomValidity('');
    }
  }, [pw, onChange, pwconf]);

  return (
    <>
      <FormGroup row>
        <Label for="password" md={mdHalf} sm={smHalf}>
          {isNew ? ts('password_change_input.New') : ''} {ts('common.password')}
        </Label>
        <Col md={md} sm={sm}>
          <NewPasswordInput minLength={6} minScore={passwordScore} onChange={setPW} />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label for="confirmPassword" md={mdHalf} sm={smHalf}>
          {ts('common.confirm_password')}
        </Label>
        <Col md={md} sm={sm}>
          <Input
            autoComplete="new-password"
            id="confirmPassword"
            innerRef={ref}
            invalid={matchError}
            onChange={setPWConf}
            type="password"
          />
          {matchError ? (
            <FormFeedback id="passwordMismatch" invalid="true">
              {ts('password_change_input.passwords_do_not_match')}
            </FormFeedback>
          ) : null}
        </Col>
      </FormGroup>
    </>
  );
};
